var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMastercard = function SvgMastercard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard",
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Master",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-1",
    d: "M45.4,0H3.4A2.581,2.581,0,0,0,1,2.4v24Q1,30,4.6,30H45.4Q49,30,49,26.4V3.6Q49,0,45.4,0Zm0,0",
    transform: "translate(-1 0)",
    fill: "#265697",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2268",
    d: "M92.268,21.04a12.489,12.489,0,1,1-24.976.006V21.04a12.489,12.489,0,1,1,24.976-.006v.006Zm0,0",
    transform: "translate(-47.405 -5.89)",
    fill: "#dfac16",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1350",
    d: "M23.862,8.425a12.624,12.624,0,0,0,.08,25.245,12.368,12.368,0,0,0,8.4-3.289h0a12.684,12.684,0,0,0,1.268-1.352H31.057a12.325,12.325,0,0,1-.931-1.3h4.413a12.687,12.687,0,0,0,.727-1.352H29.4a12.53,12.53,0,0,1-.522-1.326h6.912a12.809,12.809,0,0,0,.355-6.706H28.509a12.694,12.694,0,0,1,.356-1.326H35.78a12.7,12.7,0,0,0-.538-1.351H29.4a12.151,12.151,0,0,1,.717-1.326h4.409a12.647,12.647,0,0,0-.969-1.352H31.095a11.654,11.654,0,0,1,1.253-1.275,12.37,12.37,0,0,0-8.405-3.289Zm0,0",
    transform: "translate(-8.318 -5.897)",
    fill: "#bf3126",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4157",
    d: "M63.252,47.408l.166-1.142c-.091,0-.225.039-.343.039-.463,0-.514-.249-.484-.433l.374-2.331h.7l.17-1.264h-.663l.135-.786h-1.33c-.029.03-.785,4.419-.785,4.954a.992.992,0,0,0,1.059,1.138,3.464,3.464,0,0,0,1-.176Zm0,0",
    transform: "translate(-43.137 -29.045)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4155",
    d: "M69.454,46.715a2.1,2.1,0,0,0,2.3,2.351,3.352,3.352,0,0,0,1.4-.22l.234-1.3a4.1,4.1,0,0,1-1.412.33C70.55,47.879,70.8,46.8,70.8,46.8h2.7a9.764,9.764,0,0,0,.174-1.226,1.794,1.794,0,0,0-1.9-1.965c-1.337,0-2.327,1.456-2.327,3.1Zm2.332-1.9c.75,0,.612.852.612.921H70.921c0-.088.14-.921.864-.921Zm0,0",
    transform: "translate(-48.918 -30.529)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4151",
    d: "M96.994,46.107l.238-1.465a3.174,3.174,0,0,1-1.1.331c-.943,0-1.321-.728-1.321-1.51,0-1.587.812-2.459,1.715-2.459a2.352,2.352,0,0,1,1.221.384l.217-1.424a4.732,4.732,0,0,0-1.5-.33c-1.535,0-3.028,1.346-3.028,3.874,0,1.676.806,2.783,2.393,2.783a6.072,6.072,0,0,0,1.163-.184Zm0,0",
    transform: "translate(-65.707 -27.744)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4149",
    d: "M37.907,43.682a4.551,4.551,0,0,0-1.611.3L36.1,45.136a4.158,4.158,0,0,1,1.449-.237c.5,0,.857.056.857.463a.867.867,0,0,1-.044.338s-.391-.033-.571-.033c-1.15,0-2.358.5-2.358,1.992a1.269,1.269,0,0,0,1.284,1.449,1.725,1.725,0,0,0,1.364-.617L38.04,49h1.171l.522-3.7a1.576,1.576,0,0,0-1.826-1.621Zm.285,3.014c.025.226-.14,1.286-.941,1.286a.487.487,0,0,1-.52-.507c0-.368.2-.809,1.172-.809a.838.838,0,0,1,.289.031Zm0,0",
    transform: "translate(-25.105 -30.578)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4145",
    d: "M50.426,49.1c.3,0,2.012.077,2.012-1.709,0-1.669-1.585-1.34-1.585-2.01,0-.334.258-.439.73-.439.187,0,.909.06.909.06l.168-1.187a6.139,6.139,0,0,0-1.227-.106c-.984,0-1.982.4-1.982,1.755,0,1.539,1.665,1.384,1.665,2.032,0,.433-.465.468-.824.468a4.3,4.3,0,0,1-1.181-.2l-.177,1.175a4.18,4.18,0,0,0,1.492.165Zm0,0",
    transform: "translate(-34.554 -30.597)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4139",
    d: "M133.127,40.128l-.287,1.8a1.754,1.754,0,0,0-1.284-.7c-1.218,0-2.234,1.485-2.234,3.191,0,1.1.542,2.18,1.649,2.18a1.657,1.657,0,0,0,1.238-.561l-.058.479h1.293l1.016-6.391-1.333,0Zm-.617,3.507c0,.71-.348,1.658-1.069,1.658-.478,0-.7-.406-.7-1.043,0-1.042.463-1.729,1.047-1.729.479,0,.724.332.724,1.115Zm0,0",
    transform: "translate(-90.826 -28.088)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4133",
    d: "M16.684,46.515l.809-4.825.119,4.825h.916l1.709-4.825-.757,4.825h1.361l1.048-6.4h-2.1l-1.311,3.927-.068-3.927h-1.94l-1.063,6.4Zm0,0",
    transform: "translate(-11.081 -28.081)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4131",
    d: "M84.776,49.166c.387-2.225.459-4.031,1.382-3.7a5.21,5.21,0,0,1,.494-1.558,1.388,1.388,0,0,0-.256-.018c-.6,0-1.037.822-1.037.822l.119-.755H84.24l-.829,5.209Zm0,0",
    transform: "translate(-58.687 -30.723)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4149_1_",
    d: "M109.753,43.682a4.551,4.551,0,0,0-1.611.3l-.193,1.158A4.158,4.158,0,0,1,109.4,44.9c.5,0,.857.056.857.463a.872.872,0,0,1-.044.338s-.391-.033-.572-.033c-1.15,0-2.358.5-2.358,1.992a1.269,1.269,0,0,0,1.284,1.449,1.724,1.724,0,0,0,1.364-.617l-.044.514h1.171l.522-3.7a1.576,1.576,0,0,0-1.826-1.621Zm.285,3.014c.025.226-.14,1.286-.941,1.286a.487.487,0,0,1-.52-.507c0-.368.2-.809,1.172-.809a.843.843,0,0,1,.289.031Zm0,0",
    transform: "translate(-75.397 -30.578)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4131_1_",
    d: "M121.986,49.166c.387-2.225.459-4.031,1.382-3.7a5.22,5.22,0,0,1,.494-1.558,1.388,1.388,0,0,0-.256-.018c-.6,0-1.037.822-1.037.822l.119-.755H121.45l-.829,5.209Zm0,0",
    transform: "translate(-84.735 -30.723)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard.961b8f54.svg";
export { ForwardRef as ReactComponent };